import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  paper: {
    '& .MuiPaper-root': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  MuiDialogContentRoot: {
    padding: '0 !important',
    minWidth: 310,
    minHeight: 539,

    [Theme.breakpoints.up('md')]: {
      minWidth: 508,
    },

    [Theme.breakpoints.up('lg')]: {
      minWidth: 680,
    },
  },
}));

export default useStyles;
